const PrivacyPolicy = () => {
  return (
    <section className="privacy-policy">
      <div className="container">
        <div className="common-title">
          <h2 className="common-title__h2">
            Политика <span>конфиденциальности</span>
          </h2>
          <p className="common-title__subtitle">
            всё о том, как мы собираем и обрабатываем ваши персональные данные
          </p>
        </div>
        <div className="privacy-policy-header">
          <span>г. Москва «20» мая 2021 г.</span>
          <span>Обновлено «29» февраля 2024 г.</span>
        </div>
        <div className="privacy-policy-body">
          <p className="privacy-policy-p">
            Настоящая Политика конфиденциальности персональных данных (далее –
            Политика конфиденциальности) действует в отношении всей информации,
            которую сайт «RPM ROLEPLAY», расположенный на доменном имени
            www.rpmserver.com, может получить о Пользователе во время
            использования сайта для приема платежей в пользу игрового
            проекта RPM ROLEPLAY.
          </p>
          <h5 className="privacy-policy-title">1. ОПРЕДЕЛЕНИЕ ТЕРМИНОВ</h5>
          <p className="privacy-policy-p">
            1.1. В настоящей Политике конфиденциальности используются следующие
            термины: <br />
            1.1.1. «Администрация сайта RPM ROLEPLAY (далее – Администрация
            сайта) » – уполномоченные сотрудники на управления сайтом,
            действующие от имени RPM ROLEPLAY, которые организуют и (или)
            осуществляет обработку персональных данных, а также определяет цели
            обработки персональных данных, состав персональных данных,
            подлежащих обработке, действия (операции), совершаемые с
            персональными данными.
            <br />
            1.1.2. «Персональные данные» - любая информация, относящаяся к прямо
            или косвенно определенному или определяемому физическому лицу
            (субъекту персональных данных).
            <br />
            1.1.3. «Обработка персональных данных» - любое действие (операция)
            или совокупность действий (операций), совершаемых с использованием
            средств автоматизации или без использования таких средств с
            персональными данными, включая сбор, запись, систематизацию,
            накопление, хранение, уточнение (обновление, изменение), извлечение,
            использование, передачу (распространение, предоставление, доступ),
            обезличивание, блокирование, удаление, уничтожение персональных
            данных.
            <br />
            1.1.4. «Конфиденциальность персональных данных» - обязательное для
            соблюдения Оператором или иным получившим доступ к персональным
            данным лицом требование не допускать их распространения без согласия
            субъекта персональных данных или наличия иного законного основания.{" "}
            <br />
            1.1.5. «Пользователь сайта Ресурса (далее ‑ Пользователь)» – лицо,
            имеющее доступ к Сайту, посредством сети Интернет и использующее
            Сайт Ресурса.
            <br />
            1.1.6. «Cookies» — небольшой фрагмент данных, отправленный
            веб-сервером и хранимый на компьютере пользователя, который
            веб-клиент или веб-браузер каждый раз пересылает веб-серверу в
            HTTP-запросе при попытке открыть страницу соответствующего сайта.{" "}
            <br />
            1.1.7. «IP-адрес» — уникальный сетевой адрес узла в компьютерной
            сети, построенной по протоколу IP.
          </p>
          <h5 className="privacy-policy-title">2. ОБЩИЕ ПОЛОЖЕНИЯ</h5>
          <p className="privacy-policy-p">
            2.1. Использование Пользователем сайта RPM ROLEPLAY означает
            согласие с настоящей Политикой конфиденциальности и условиями
            обработки персональных данных Пользователя.
            <br />
            2.2. В случае несогласия с условиями Политики конфиденциальности
            Пользователь должен прекратить использование сайта RPM ROLEPLAY.
            <br />
            2.3. Настоящая Политика конфиденциальности применяется только к
            сайту RPM ROLEPLAY. RPM ROLEPLAY не контролирует и не несет
            ответственность за сайты третьих лиц, на которые Пользователь может
            перейти по ссылкам, доступным на сайте RPM ROLEPLAY. <br />
            2.4. Администрация сайта не проверяет достоверность персональных
            данных, предоставляемых Пользователем сайту RPM ROLEPLAY.
          </p>
          <h5 className="privacy-policy-title">
            3. ПРЕДМЕТ ПОЛИТИКИ КОНФИДЕНЦИАЛЬНОСТИ
          </h5>
          <p className="privacy-policy-p">
            3.1. Настоящая Политика конфиденциальности устанавливает
            обязательства Администрации сайта RPM ROLEPLAY по неразглашению и
            обеспечению режима защиты конфиденциальности персональных данных,
            которые Пользователь предоставляет по запросу Администрации сайта
            при регистрации на сайте RPM ROLEPLAY.
            <br />
            3.2. Персональные данные, разрешённые к обработке в рамках настоящей
            Политики конфиденциальности, предоставляются Пользователем путем
            регистрации на сайте RPM ROLEPLAY: <br />
            3.2.1. адрес электронной почты (e-mail); <br />
            3.3. Ресурс защищает Данные, которые автоматически передаются в
            процессе регистрации на сайте RPM ROLEPLAY: IP адрес;
            <br />
            3.3.1. Ресурс осуществляет сбор статистики об IP-адресах своих
            посетителей. Данная информация используется с целью выявления и
            решения технических проблем и обеспечения безопасности сайта.
            <br />
            3.4. Любая иная персональная информация неоговоренная выше (история
            платежей, используемые браузеры и операционные системы и т.д.)
            подлежит надежному хранению и нераспространению, за исключением
            случая, предусмотренного в п.п. 5.2. настоящей Политики
            конфиденциальности.
          </p>
          <h5 className="privacy-policy-title">
            4. ЦЕЛИ СБОРА ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ ПОЛЬЗОВАТЕЛЯ
          </h5>
          <p className="privacy-policy-p">
            4.1. Персональные данные Пользователя Администрация сайта Ресурса
            может использовать в целях:
            <br />
            4.1.1. Идентификации Пользователя, зарегистрированного на сайте RPM
            ROLEPLAY.
            <br />
            4.1.2. Предоставления Пользователю доступа к персонализированным
            ресурсам сайта RPM ROLEPLAY.
            <br />
            4.1.3. Установления с Пользователем обратной связи, включая
            направление уведомлений, запросов, касающихся использования Сайта
            RPM ROLEPLAY, оказания услуг, обработка запросов и заявок от
            Пользователя.
            <br />
            4.1.4. Определения места нахождения Пользователя для обеспечения
            безопасности, предотвращения мошенничества.
            <br />
            4.1.5. Предоставления Пользователю эффективной клиентской и
            технической поддержки при возникновении проблем связанных с
            использованием Сайта RPM ROLEPLAY.
          </p>
          <h5 className="privacy-policy-title">
            5. СПОСОБЫ И СРОКИ ОБРАБОТКИ ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ
          </h5>
          <p className="privacy-policy-p">
            5.1. Обработка персональных данных Пользователя осуществляется без
            ограничения срока, любым законным способом, в том числе в
            информационных системах персональных данных с использованием средств
            автоматизации или без использования таких средств. <br />
            5.2. Персональные данные Пользователя могут быть переданы
            уполномоченным органам государственной власти Российской Федерации
            только по основаниям и в порядке, установленным законодательством
            Российской Федерации.
            <br />
            5.3. При утрате или разглашении персональных данных Администрация
            сайта информирует Пользователя об утрате или разглашении
            персональных данных.
            <br />
            5.4. Администрация сайта принимает необходимые организационные и
            технические меры для защиты персональной информации Пользователя от
            неправомерного или случайного доступа, уничтожения, изменения,
            блокирования, копирования, распространения, а также от иных
            неправомерных действий третьих лиц.
            <br />
            5.5. Администрация сайта совместно с Пользователем принимает все
            необходимые меры по предотвращению убытков или иных отрицательных
            последствий, вызванных утратой или разглашением персональных данных
            Пользователя.
          </p>
          <h5 className="privacy-policy-title">6. ОБЯЗАТЕЛЬСТВА СТОРОН</h5>
          <p className="privacy-policy-p">
            6.1. Пользователь обязан:
            <br />
            6.1.1. Предоставить информацию о персональных данных, необходимую
            для пользования Сайтом RPM ROLEPLAY.
            <br />
            6.1.2. Обновить, дополнить предоставленную информацию о персональных
            данных в случае изменения данной информации.
            <br />
            6.2. Администрация сайта обязана:
            <br />
            6.2.1. Использовать полученную информацию исключительно для целей,
            указанных в п. 4 настоящей Политики конфиденциальности. <br />
            6.2.2. Обеспечить хранение конфиденциальной информации в тайне, не
            разглашать без предварительного письменного разрешения Пользователя,
            а также не осуществлять продажу, обмен, опубликование, либо
            разглашение иными возможными способами переданных персональных
            данных Пользователя, за исключением п.п. 5.2. настоящей Политики
            Конфиденциальности.
            <br />
            6.2.3. Принимать меры предосторожности для защиты конфиденциальности
            персональных данных Пользователя.
            <br />
            6.2.4. Осуществить блокирование персональных данных, относящихся к
            соответствующему Пользователю, с момента обращения или запроса
            Пользователя или его законного представителя либо уполномоченного
            органа по защите прав субъектов персональных данных на период
            проверки, в случае выявления недостоверных персональных данных или
            неправомерных действий.
          </p>
          <h5 className="privacy-policy-title">7. ОТВЕТСТВЕННОСТЬ СТОРОН</h5>
          <p className="privacy-policy-p">
            7.1. Администрация сайта, не исполнившая свои обязательства, несёт
            ответственность за убытки, понесённые Пользователем в связи с
            неправомерным использованием персональных данных, в соответствии с
            законодательством Российской Федерации, за исключением случаев,
            предусмотренных п.п. 5.2. и 7.2. настоящей Политики
            Конфиденциальности. <br />
            7.2. В случае утраты или разглашения Конфиденциальной информации
            Администрация сайта не несёт ответственность, если данная
            конфиденциальная информация:
            <br />
            7.2.1. Стала публичным достоянием до её утраты или разглашения.
            <br />
            7.2.2. Была получена от третьей стороны до момента её получения
            Администрацией сайта.
            <br />
            7.2.3. Была разглашена с согласия Пользователя.
          </p>
          <h5 className="privacy-policy-title">8. РАЗРЕШЕНИЕ СПОРОВ</h5>
          <p className="privacy-policy-p">
            8.1. До обращения в суд с иском по спорам, возникающим из отношений
            между Пользователем сайта Ресурса и Администрацией сайта,
            обязательным является предъявление претензии (письменного
            предложения о добровольном урегулировании спора).
            <br />
            8.2 .Получатель претензии в течение 30 календарных дней со дня
            получения претензии, письменно уведомляет заявителя претензии о
            результатах рассмотрения претензии. <br />
            8.3. При не достижении соглашения спор будет передан на рассмотрение
            в судебный орган в соответствии с действующим законодательством
            Российской Федерации.
            <br />
            8.4. К настоящей Политике конфиденциальности и отношениям между
            Пользователем и Администрацией сайта применяется действующее
            законодательство Российской Федерации.
          </p>
          <h5 className="privacy-policy-title">9. ДОПОЛНИТЕЛЬНЫЕ УСЛОВИЯ</h5>
          <p className="privacy-policy-p">
            9.1. Администрация сайта вправе вносить изменения в настоящую
            Политику конфиденциальности без согласия Пользователя.
            <br />
            9.2. Новая Политика конфиденциальности вступает в силу с момента ее
            размещения на Сайте Ресурса, если иное не предусмотрено новой
            редакцией Политики конфиденциальности.
            <br />
            9.3. Все предложения или вопросы по настоящей Политике
            конфиденциальности следует сообщать указать раздел сайта Ресурса.{" "}
            <br />
            9.4. Действующая Политика конфиденциальности размещена на странице
            по адресу www.rpmserver.com.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
